import React from "react";
import "./About.css";

import graduation from '../Images/blaineGraduation.jpg';

export default function About() {
  return (
    <main className="About">
      <div className="about-grid">
        <div className="about-media">
          <img src={graduation} alt="Dr. Blaine Harteis at graduation" className="graduation" />
        </div>
        <div className="card aboutInfo">
          <p className="section-eyebrow">Meet Your Physical Therapist</p>
          <h1 className="aboutTitle">Dr. Blaine Harteis, PT, DPT</h1>
          <hr />
          <p className="text">
            Earning his Doctorate in Physical Therapy from Seton Hill University in 2024 and
            obtaining his license shortly after, Blaine began his career at an outpatient clinic
            in Indiana, Pennsylvania. There, he worked with a wide range of patients — from
            pediatrics to Division I athletes — helping each achieve their unique goals.
          </p>
          <p className="text">
            Blaine is passionate about improving strength, mobility, and quality of life within
            the community. He has a special interest in orthopedic physical therapy, with a
            focus on personalized, evidence-based care.
          </p>
        </div>
      </div>
    </main>
  );
}
